// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4455":"d3dcbb074023dcb3","7275":"e3e47c47fdf8d64f"}[chunkId] + ".css";
};